import { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import DashboardPage from '../pages/dashboard/DashboardPage';
import InvoicePage from '../pages/Invoice/InvoicePage';
import NotificationsPage from '../pages/notifications/NotificationsPage';
const PrivateRoutes = () => {
  const token = localStorage.getItem('token'); 

  useEffect(() => {
  }, []);

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {token ? (
          <>
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="invoice" element={<InvoicePage />} />
            {/* <Route path="notifications" element={<NotificationsPage />} /> */}
          </>
        ) : (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}

        {/* Page Not Found */}
        {/* <Route path='*' element={<Navigate to='/error/404' />} /> */}
      </Route>
    </Routes>
  )
}

export { PrivateRoutes }
